import { render, staticRenderFns } from "./two-status-widget.vue?vue&type=template&id=0e719a06"
import script from "./two-status-widget.vue?vue&type=script&lang=ts"
export * from "./two-status-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports